'use client';

import React from 'react';
import { useTranslation } from '@app/i18n/useTranslationClient';
import { useCountdown } from '@/hooks/useCountdown';
import { Countdown } from '@/components/countdownClock/Countdown';

interface ICountdownClock {
    endDate: string;
}

export const CountdownClock: React.FC<ICountdownClock> = ({ endDate }) => {
    const { t } = useTranslation();
    const [days, hours, minutes] = useCountdown(endDate);

    const shouldShowCountdown = new Date(endDate) > new Date();

    return shouldShowCountdown && <Countdown days={days} hours={hours} minutes={minutes} t={t} />;
};
